import { createSlice } from '@reduxjs/toolkit';
import {
  AssignLabelsAction,
  ImagingLabelsFetchAction,
  ImagingLabelsFetchSuccessAction,
  ImagingLabelsState,
  UnAssignLabelsAction,
} from './imagingLabels.types';
import { createSliceHook, makeActionCreator } from '../helpers';

const initialState: ImagingLabelsState = {
  data: [],
  loading: false,
  error: undefined,
};

const { actReq, actResolve, actReject } =
  makeActionCreator<ImagingLabelsState>();

export const imagingLabelsSlice = createSlice({
  name: 'imagingLabels',

  initialState,
  reducers: {
    fetchImagingLabels: actReq<ImagingLabelsFetchAction['payload']>('loading'),
    fetchImagingLabelsSuccess: actResolve<
      ImagingLabelsFetchSuccessAction['payload']
    >('data', 'loading'),
    fetchImagingLabelsError: actReject('loading'),
    resetImagingLabels: state => {
      state.data = [];
    },
    assignLabelsRequest: actReq<AssignLabelsAction['payload']>('loading'),
    assignLabelsSuccess: actResolve<null>('loading'),
    assignLabelsFailure: actReject<null>('loading'),
    unAssignLabelsRequest: actReq<UnAssignLabelsAction['payload']>('loading'),
    unAssignLabelsSuccess: actResolve<null>('loading'),
    unAssignLabelsFailure: actReject<null>('loading'),
  },
});

export const {
  fetchImagingLabels,
  fetchImagingLabelsSuccess,
  fetchImagingLabelsError,
  resetImagingLabels,
} = imagingLabelsSlice.actions;

export const actions = {
  ...imagingLabelsSlice.actions,
};

export const useImagingLabelsSlice = createSliceHook(
  imagingLabelsSlice.name,
  actions
);
